import { ScheduledEmailType } from '@dealstack/shared/lib/backendClient';
import type { ConfigCardFormValues } from './ConfigCard.types';

export const CONFIG_TYPE_LABEL_KEYS: Record<
	ScheduledEmailType,
	{ title: string; description: string }
> = {
	[ScheduledEmailType.DOCUMENT_SIGNING_REMINDER]: {
		title: 'automated_emails.configuration.document_signing_reminder.title',
		description: 'automated_emails.configuration.document_signing_reminder.description',
	},
};

export const buildConfigPreviewLine = ({
	enabled,
	initialDelayDays,
	intervalDays,
	maxFires,
}: Omit<ConfigCardFormValues, 'endDate'>): string => {
	if (!enabled) {
		return 'This reminder is turned off and will not be sent.';
	}

	const dayLabel = (days: number) => (days === 1 ? 'day' : 'days');
	const timesLabel = maxFires === 1 ? 'time' : 'times';

	return (
		`Sends ${initialDelayDays} ${dayLabel(initialDelayDays)} after a workflow is issued, ` +
		`then every ${intervalDays} ${dayLabel(intervalDays)}, up to ${maxFires} ${timesLabel} — ` +
		`only to signers still unsigned. Stops early once everyone signs.`
	);
};
